var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.43 74.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m117.38,46.92c7.87-8.62,19.47-20.33,27.5-28.39,3.94-3.95,8.7-9.03,5.48-14.47-4.48-7.6-11.23-2.19-11.23-2.19-8.05,7.56-19.27,19.34-26.97,27.69-7.8,8.18-15.08,18.05-21.98,22.95-3.52,2.48-6.78,3.52-10.09,3.04-3.38-.48-7.14-2.54-11.11-5.31-8.17-5.78-16.33-12.19-24.26-18.98-9.48-8.13-18.86-17.02-28.46-25.72,0,0-8.97-6.6-13.91-1.49-4.95,5.11-1.78,10.32,6.29,17.56,15.92,14.29,26.81,23.81,27.9,24.25,6.12,5.31,12.37,10.4,18.71,15.21,3.2,2.39,6.28,4.74,9.67,7.01,3.39,2.25,7.07,4.4,11.15,5.55,4.08,1.24,8.67,1.05,12.77-.55,4.12-1.58,7.81-4.26,11.12-7.25,6.62-6.14,11.84-12.93,17.41-18.92",
    fill: "#2c3037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/Down-Arrow.cb52b132a8c2cc2a41121445f3052bd2.svg";
export { ForwardRef as ReactComponent };